import { TFunction } from 'react-i18next';
import { Currency, formatCurrency } from '@chargify/formatters';

type Params = {
  accrueCharge: boolean;
  t: TFunction<'subscriptions-manager'[]>;
  currency: Currency;
  language: string;
  totalAmountInCents: number;
};
export const getAllocationSummaryPaymentMessage = ({
  accrueCharge,
  t,
  currency,
  language,
  totalAmountInCents,
}: Params) => {
  if (totalAmountInCents <= 0) {
    return {
      title: t('components_allocations.there_are_no_new_charges'),
    };
  }
  if (accrueCharge) {
    return {
      title: t('components_allocations.no_payment_is_required_now'),
      description: t(
        'components_allocations.your_account_will_carry_forward_balance',
        { amount: formatCurrency(currency, totalAmountInCents, language) }
      ),
    };
  }
  return {
    title: t('components_allocations.you_will_be_charged', {
      amount: formatCurrency(currency, totalAmountInCents, language),
    }),
    description: t(
      'components_allocations.if_the_payment_fails_the_charge_will_be_carried'
    ),
  };
};
